import React, { Component } from 'react';
// import { connect } from 'react-redux';
import { Link, withRouter } from 'react-router-dom';
import './hoverCard.scss';

class HoverCard extends Component {
  constructor(props) {
    super(props);

    this.state = {
      hideTtile: false
    }
  }

  componentDidMount() {
    const { hideTtile } = this.props;
    // console.log('hdie', hideTtile);
    if (hideTtile) {
      this.setState({ hideTtile })
    }
  }

  linkToExpert() {
    this.props.history.push('/resources')
  }

  render() {
    const { hideTtile } = this.state;
    const { hoverCardData, hasBackGroud, title, hideMore, noSpaceBottom } = this.props;
    // console.log('hoverCardData', hoverCardData);

    return (
      <div className={`hover-card ${hasBackGroud ? 'hasBackGroud' : ''} `}>
        <div className={`hover-card__content ${noSpaceBottom ? 'noSpaceBottom' : ''} `}>

          {
            !hideTtile ? (
              <div className="hover-card__head">
                <h2 className="title">{title}</h2>
                <span className="line"></span>
              </div>
            ) : null
          }

          <ul className="hover-card__group">
            {
              hoverCardData.map((item) => {
                return (
                  <li className="hover-card__item" key={item.get('id')}>
                    <div className="b_img">
                      <img className="hover-card__item--pic" src={item.get('headimg')}></img>
                      <div className="hover-card__item--info-box1">
                        <h3 className="name">{item.get('name')}</h3>
                        {
                          item.get('rank') ? (
                            <p className="title">{item.get('rank')}</p>
                          ) :  <p className="placeholder"></p>
                        }
                        {
                          item.get('company') ? (
                            <p className="l-desc">{item.get('company')}</p>
                          ) : null
                        }
                      </div>
                    </div>
                  </li>
                )
              })
            }
          </ul>

          {
            hideMore ? null : (
              <div className="hover-card__more">
                <button className="link" onClick={this.linkToExpert.bind(this)}>查看更多 <i className="iconfont">&#xe664;</i></button>
              </div>
            )
          }

        </div>
      </div>
    )
  }
}

export default withRouter(HoverCard);
